import { FormUserAdminLayout, MenuLayout } from "../layouts";

export const EditUserPage = () => {
  return (
    <>
      <MenuLayout>
        <FormUserAdminLayout isEditMode={true} titlePage="Edición de Usuario" />
      </MenuLayout>
    </>
  );
};
